export default __webpack_public_path__ + "static/media/cc_3.9b9c6aa9.mp3";